import { signal } from '@preact/signals-react'

export const notificationsSignal = signal([])